import React from 'react';
import {Template} from "../../components/template/template.jsx";
import {Link} from "react-router";
import {Card} from "../../components/card/card.jsx";
import {FaPhone} from "react-icons/fa";
import {FaRotateLeft} from "react-icons/fa6";

const Unauthorized = () => {
    return (
        <Template>
            <Template.Header>
                <Template.Title className={"flex gap-2 items-center "}>
                    <Link to="/home" className={"!text-gray-600 !cursor-pointer"}>
                        <FaRotateLeft />
                    </Link>
                    Voltar para a página inicial
                </Template.Title>
            </Template.Header>
            <Template.Body className={"flex justify-center items-center h-full"}>
                <Card className={"shadow-md"}>
                    <Card.Body className={"flex flex-col items-center gap-4 !p-7 w-[420px]"}>
                        <p className={"!text-6xl font-bold"}>401</p>
                        <h3 className="uppercase">Acesso negado.</h3>

                        <hr className={"w-full opacity-25"}/>

                        <Link to="/contacts" className={"flex gap-2 items-center !text-gray-600 cursor-pointer"}>
                            <FaPhone /> Suporte técnico
                        </Link>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default Unauthorized;